export { default } from './AuthenticatedLayout';



// WEBPACK FOOTER //
// src/components/layout/AuthenticatedLayout/index.js